import React from "react";
import styles from "./styles/DashboardCard.module.css";
import CountUp from "react-countup";
import { Badge, Placeholder, Spinner } from "react-bootstrap";
import { IoIosTrendingUp } from "react-icons/io";
import DashboardCardSkeleton from "../Skeleton/DashboardCardSkeleton";
// import { CiUser } from "react-icons/ci";

const SalesCard = ({
  bg1 = "",
  bg2 = "",
  icon,
  number,
  text,
  loading,
  before_number = "",
  after_number = "",
  percentage = "",
  bottomText = "",
  isTime = false,
}) => {
  return loading ? (
    <DashboardCardSkeleton styles={styles} />
  ) : (
    <div
      className={`${styles.Card} shadow h-auto`}
      style={{
        backgroundImage: `linear-gradient(0deg, ${bg1} 0%, ${bg2} 80%)`,
      }}
    >
      <div className="d-flex justify-content-between align-items-center w-100">
        <p className=" m-0">{text}</p>
        <div className={`${styles.iconCard}`}>{icon}</div>
      </div>

      <div className="d-flex justify-content-between align-items-center w-100">
        {loading ? (
          <Spinner color="black" />
        ) : (
          <>
            <p className="fs-5 fw-bold m-0">
              {before_number}{" "}
              {isTime ? number : <CountUp end={Number(number).toFixed(2)} />}{" "}
              {after_number}
            </p>
            <span className="text-success">{percentage}</span>
          </>
        )}
      </div>
      <span className="text-black-50 small">{bottomText}</span>
    </div>
  );
};

export default SalesCard;
